export default __webpack_public_path__ + "static/media/go4emr.74bf1c8a.svg";